"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Engine = void 0;
const protocol_1 = require("../protocol");
const constants_1 = require("./constants");
const utils_1 = require("../utils");
const iconnector_1 = require("../connector/iconnector");
const connectionManager_1 = require("./connectionManager");
const sessionUtils_1 = require("./sessionUtils");
const wallet_info_1 = require("../protocol/connect/wallet-info");
class Engine {
    constructor(appName) {
        this.connectors = [];
        this.useConnector = undefined;
        this.connectionManager = new connectionManager_1.ConnectionManager(appName);
        this.addConnectionListener();
    }
    getConnector() {
        if (this.useConnector) {
            return this.useConnector;
        }
    }
    setAccountChangeListener(accountChangeListener) {
        this.accountChangeListener = accountChangeListener;
        (0, utils_1.logDebug)("setAccountChangeListener: engine", accountChangeListener);
        for (const connector of this.connectors) {
            connector.setAccountChangeListener(accountChangeListener);
        }
    }
    registerConnector(connectors) {
        this.connectors = connectors;
        for (const connector of connectors) {
            connector.setConnectionManager(this.connectionManager);
        }
    }
    hasWsConnector() {
        for (const connector of this.connectors) {
            if (this.isWsConnector(connector)) {
                return true;
            }
        }
        return false;
    }
    isWsConnector(connector) {
        if (!connector)
            return false;
        return (connector.getTag() === iconnector_1.OKX_TG_WALLET
            || connector.getTag() === iconnector_1.OKX_APP_WALLET);
    }
    isInjectedConnector(connector) {
        if (!connector)
            return false;
        return connector.getTag() === iconnector_1.OKX_INJECT_WALLET;
    }
    universalConnect(request, sessionConfig, connectInfoAndUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addConnectionListener();
            return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c, _d;
                try {
                    (0, utils_1.logDebug)("engine universalConnect request :", JSON.stringify(request));
                    (0, utils_1.logDebug)("engine universalConnect sessionConfig :", JSON.stringify(sessionConfig));
                    let universalRequest = [];
                    request.forEach((item) => {
                        let name = item.name;
                        if (name.startsWith("requestAccounts") || name.startsWith("ton")) {
                            universalRequest.push(item);
                        }
                    });
                    (0, utils_1.logDebug)("engine universalConnect universalRequest :", JSON.stringify(universalRequest));
                    const connectInfo = this.connectionManager.getConnectInfo();
                    const requestId = Date.now().toString();
                    let openUniversalLink = (_a = sessionConfig.openUniversalUrl) !== null && _a !== void 0 ? _a : false;
                    const universalConnectRequest = {
                        protocolVer: Number(protocol_1.tonConnectSdkVersion),
                        topic: connectInfo.channelId,
                        clientId: connectInfo.clientId,
                        requestId: requestId,
                        dAppInfo: sessionConfig.dappInfo,
                        requests: universalRequest,
                        redirect: (_b = sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.redirect) !== null && _b !== void 0 ? _b : "none"
                    };
                    const base64Encoded = (0, utils_1.encodeConnectParams)(universalConnectRequest);
                    universalConnectRequest.redirect = (_c = sessionConfig === null || sessionConfig === void 0 ? void 0 : sessionConfig.redirect) !== null && _c !== void 0 ? _c : "none";
                    (0, utils_1.logDebug)('engine universalConnect ==>>universalConnectRequest:', JSON.stringify(universalConnectRequest));
                    var openOKXLink = "";
                    // open app wallet
                    if (openUniversalLink) {
                        openOKXLink = (0, utils_1.getOKXLink)(universalConnectRequest, sessionConfig.useMini, sessionConfig.tmaReturnUrl);
                        (0, utils_1.logDebug)('engine universalConnect ==>>openOKXLink:', openOKXLink);
                    }
                    const openMethod = () => {
                        if (this.connectors.length == 1 && this.connectors[0].getTag() === iconnector_1.OKX_INJECT_WALLET) {
                            return this.connectors[0].openWallet({
                                connectRequest: universalConnectRequest
                            });
                        }
                        else {
                            if (sessionConfig.useMini) {
                                return (0, utils_1.openOKXTMAWalletlinkWithFallback)(openOKXLink);
                            }
                            if ((0, utils_1.useShortLink)()) {
                                return (0, utils_1.openOKXUniversalLink)(openOKXLink);
                            }
                            return (0, utils_1.openOKXDeeplinkWithFallback)(openOKXLink);
                        }
                    };
                    (0, utils_1.logDebug)('engine universalConnect ==>>openOKXLink:', openOKXLink);
                    const isIOS = (0, utils_1.isIos)();
                    if (isIOS && openUniversalLink) {
                        (0, utils_1.logDebug)(`engine universalConnect ==>>isIOS: ${isIOS}   openUniversalLink: ${openUniversalLink}`);
                        openMethod();
                    }
                    this.addOnConnectResultListener((response) => {
                        var _a, _b, _c, _d;
                        try {
                            this.addOnConnectResultListener(undefined);
                            let connectResponse = response;
                            if (connectResponse.method == "connect") {
                                (0, utils_1.logDebug)("engin  universalConnect success connectResponse:>>>", JSON.stringify(connectResponse));
                                let namespaces = (0, sessionUtils_1.buildNameSpacesByConnectResponse)(connectResponse);
                                if (namespaces) {
                                    let walletName = undefined;
                                    if (((_b = (_a = connectResponse.payload) === null || _a === void 0 ? void 0 : _a.responses) === null || _b === void 0 ? void 0 : _b[0]) && "walletName" in connectResponse.payload.responses[0]) {
                                        walletName = connectResponse.payload.responses[0]['walletName'];
                                    }
                                    let appName = (_c = connectResponse.payload) === null || _c === void 0 ? void 0 : _c.wallet.appName;
                                    var tag;
                                    switch (appName) {
                                        case wallet_info_1.OKXWalletName:
                                            tag = iconnector_1.OKX_APP_WALLET;
                                            break;
                                        case wallet_info_1.OKXMiniWalletName:
                                            tag = iconnector_1.OKX_TG_WALLET;
                                            break;
                                        case wallet_info_1.OKXInjectWalletName:
                                            tag = iconnector_1.OKX_INJECT_WALLET;
                                            break;
                                    }
                                    var connector = this.connectors.find((connector) => connector.getTag() === tag);
                                    if (!connector) {
                                        throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
                                    }
                                    let session = Object.assign({ topic: connectInfo.channelId, sessionConfig: sessionConfig, namespaces: namespaces }, (connectResponse.payload && {
                                        wallet: Object.assign(Object.assign({}, connectResponse.payload.wallet), { walletName: walletName })
                                    }));
                                    let methodsResponse = connectResponse.payload.responses.find(item => item.name === 'requestAccounts');
                                    if (methodsResponse && methodsResponse.connectRequestMethods) {
                                        session.signResponse = methodsResponse.connectRequestMethods;
                                    }
                                    (0, utils_1.logDebug)("engin  universalConnect success session:>>>", JSON.stringify(session));
                                    if (this.isWsConnector(connector)) {
                                        (0, utils_1.logDebug)("engine update protocol version");
                                        this.connectionManager.updateProtocolVersion(connectInfo.channelId, connectResponse.payload.wallet.maxProtocolVersion);
                                    }
                                    resolve(session);
                                    this.setUseConnector(connector);
                                }
                                else {
                                    throw new protocol_1.OKXConnectError(protocol_1.OKX_CONNECT_ERROR_CODES.UNKNOWN_ERROR);
                                }
                            }
                            else if (connectResponse.method == "connect_error" && ((_d = connectResponse.payload) === null || _d === void 0 ? void 0 : _d.code) != undefined) {
                                throw new protocol_1.OKXConnectError(connectResponse.payload.code);
                            }
                        }
                        catch (e) {
                            reject(e);
                        }
                    });
                    if (this.hasWsConnector()) {
                        yield ((_d = this.connectionManager) === null || _d === void 0 ? void 0 : _d.disconnect(false));
                        try {
                            yield this.connectionManager.connect();
                        }
                        catch (e) {
                            (0, utils_1.logDebug)('Engine universalConnect error', e);
                            throw e;
                        }
                        (0, utils_1.logDebug)('engin  universalConnect ==>> connectInfoAndUrl:', connectInfoAndUrl);
                        this.sendSession(base64Encoded);
                    }
                    if (!isIOS && openUniversalLink) {
                        openMethod();
                    }
                    (0, utils_1.logDebug)('engin  universalConnect ==>> connectInfoAndUrl:', connectInfoAndUrl);
                    if (connectInfoAndUrl) {
                        const info = {
                            connectRequest: universalConnectRequest,
                            redirect: sessionConfig.redirect,
                            tmaReturnUrl: sessionConfig.tmaReturnUrl,
                        };
                        (0, utils_1.logDebug)("universalConnect connectInfoAndUrl info :", JSON.stringify(info));
                        connectInfoAndUrl(info);
                    }
                }
                catch (error) {
                    (0, utils_1.logDebug)("Engine universalConnect catch error", error);
                    reject(error);
                }
            }));
        });
    }
    addOnConnectResultListener(connectResultListener) {
        for (const connector of this.connectors) {
            if (this.isInjectedConnector(connector)) {
                connector.setOnConnectResultListener(connectResultListener);
            }
        }
        this.connectResultListener = connectResultListener;
    }
    openWallet(engineConnectInfo, connector) {
        var _a;
        if (connector) {
            connector.openWallet(engineConnectInfo);
        }
        else {
            (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.openWallet(engineConnectInfo);
        }
    }
    send(request, requestAnswer, ttl) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            return (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.send(request, requestAnswer, ttl);
        });
    }
    clearData() {
        var _a;
        (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.clearData();
    }
    addDisconnectListener(disconnecter) {
        var _a;
        (_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.addDisconnectListener(disconnecter);
    }
    saveSessionContent(key, data) {
        this.connectionManager.saveSessionContent(key, data);
    }
    getSessionContent(key) {
        var _a;
        var session = this.connectionManager.getSessionContent(key);
        if (session) {
            var tag = "";
            if (typeof session === "object") {
                tag = this.getTagByappName((_a = session.wallet) === null || _a === void 0 ? void 0 : _a.appName);
            }
            if (this.connectors.find((connector) => {
                return connector.getTag() === tag;
            })) {
                return session;
            }
        }
        return undefined;
    }
    getTagByappName(appName) {
        var tag = '';
        if (appName) {
            switch (appName) {
                case wallet_info_1.OKXWalletName:
                    tag = iconnector_1.OKX_APP_WALLET;
                    break;
                case wallet_info_1.OKXMiniWalletName:
                    tag = iconnector_1.OKX_TG_WALLET;
                    break;
                case wallet_info_1.OKXInjectWalletName:
                    tag = iconnector_1.OKX_INJECT_WALLET;
            }
        }
        return tag;
    }
    setConnectConnector(wallet) {
        var tag = this.getTagByappName(wallet === null || wallet === void 0 ? void 0 : wallet.appName);
        if (!tag)
            return;
        this.setUseConnector(this.connectors.find((connector) => {
            return connector.getTag() === tag;
        }));
    }
    setUseConnector(connector) {
        this.useConnector = connector;
        if (this.isWsConnector(connector)) {
            connector.addConnectionListener();
        }
    }
    // for es connect
    setSessionConnectingListener(sessionConnectingListener) {
        this.sessionConnectingListener = sessionConnectingListener;
    }
    restoreconnect(sessionInfo, onConnectResult) {
        return __awaiter(this, void 0, void 0, function* () {
            var _a;
            yield ((_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.restoreconnect(sessionInfo, onConnectResult));
        });
    }
    restoreconnectFromTopic(topic) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.isWsConnector(this.getConnector())) {
                yield this.getConnector().restoreconnectFromTopic(topic);
            }
        });
    }
    getCurrentConnectionReady(namespaceKeys) {
        var _a;
        return !!((_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.getCurrentConnectionReady(namespaceKeys));
    }
    connectManagerDisconnect() {
        return __awaiter(this, arguments, void 0, function* (fromRestore = false) {
            var _a;
            yield ((_a = this.getConnector()) === null || _a === void 0 ? void 0 : _a.connectManagerDisconnect(fromRestore));
        });
    }
    sendSession(sessionInfo) {
        return __awaiter(this, void 0, void 0, function* () {
            (0, utils_1.logDebug)('[Connect] sendSession called:', sessionInfo);
            const requestId = Date.now().toString();
            let request = {
                method: 'session_info',
                params: { protocolVersion: constants_1.CONNECT_PROTOCOL_VER, sessionInfo: sessionInfo }
            };
            yield this.connectionManager.sendRaw(JSON.stringify(Object.assign(Object.assign({}, request), { requestId: requestId })));
        });
    }
    addConnectionListener() {
        var _a;
        (_a = this.connectionManager) === null || _a === void 0 ? void 0 : _a.addListener("sdk_response", (event, msg) => {
            var jsonResponse = (0, utils_1.safeJsonParse)(msg);
            (0, utils_1.logDebug)(`Engine ==>> addListener ==> success ==> ${jsonResponse}`);
            if (jsonResponse.method === 'connect' || jsonResponse.method === 'connect_error') {
                if (this.connectResultListener) {
                    this.connectResultListener(jsonResponse);
                }
            }
            else if (jsonResponse.method === "session_connecting") {
                (0, utils_1.logDebug)("Engine ==>> handleResponse_4  ===> sessionConnectingListener");
                if (this.sessionConnectingListener) {
                    (0, utils_1.logDebug)("Engine ==>> handleResponse_4  ===> sessionConnectingListener not null");
                    this.sessionConnectingListener();
                    this.sessionConnectingListener = undefined;
                }
            }
        }, function () {
        });
    }
}
exports.Engine = Engine;
